import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "60",
  height: "40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 5a5 5 0 0 1 5-5h50a5 5 0 0 1 5 5v30a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5Z",
      fill: "#179BD7"
    }, null, -1),
    _createElementVNode("path", {
      opacity: ".33",
      d: "M37.856 14.607c-.02.131-.044.265-.07.403-.905 4.644-4 6.25-7.953 6.25h-2.012a.978.978 0 0 0-.966.827l-1.031 6.535-.292 1.853a.515.515 0 0 0 .508.595h3.57a.859.859 0 0 0 .849-.724l.035-.181.672-4.266.043-.233a.858.858 0 0 1 .848-.726h.534c3.459 0 6.166-1.404 6.958-5.468.33-1.697.16-3.114-.716-4.111a3.41 3.41 0 0 0-.977-.754Z",
      fill: "#fff"
    }, null, -1),
    _createElementVNode("path", {
      d: "M28.031 14.63a.855.855 0 0 1 .848-.724h5.377c.637 0 1.231.042 1.774.13a7.158 7.158 0 0 1 1.083.258c.267.088.515.193.744.313.27-1.716-.002-2.885-.93-3.943C35.904 9.499 34.057 9 31.694 9h-6.86a.98.98 0 0 0-.97.829L21.008 27.94a.59.59 0 0 0 .582.681h4.235l1.063-6.747 1.144-7.244Z",
      fill: "#fff"
    }, null, -1),
    _createElementVNode("path", {
      opacity: ".66",
      d: "M36.91 14.23a7.119 7.119 0 0 0-.88-.195 11.187 11.187 0 0 0-1.774-.13h-5.377a.853.853 0 0 0-.848.726l-1.144 7.245-.032.21a.978.978 0 0 1 .966-.827h2.012c3.953 0 7.049-1.605 7.953-6.25.027-.137.05-.27.07-.402a4.817 4.817 0 0 0-.946-.377Z",
      fill: "#fff"
    }, null, -1)
  ]))]))
}
export default { render };